var map = {
	"./world heart day BLS 2.jpeg": 42326,
	"./world heart day BLS 3.jpeg": 7293,
	"./world heart day BLS 4.jpeg": 78728,
	"./world heart day BLS 5.jpeg": 9247,
	"./world heart day BLS.jpeg": 39532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14848;